export default __webpack_public_path__ + "static/media/arcs-logo.7dc62ca9.png";